export const ADMIN_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Admin Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },
  { slug: 'link', name: 'Inbox', href: '/inbox', icon: 'cilEnvelopeClosed' },
  { slug: 'link', name: 'Analytics', href: '/analytics', icon: 'cilChartPie' },
  { slug: 'link', name: 'Shipping Dashboard', href: '/shipping/dashboard', icon: 'cilRoute' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Tele Sales', href: '/telesales', icon: 'cilPhone' },
  { slug: 'link', name: 'Order Form', href: '/orderform', icon: 'cilPencil' },
  { slug: 'link', name: 'POS', href: '/pos', icon: 'cilCalculator' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
  { slug: 'link', name: 'Field Sales Form', href: '/fieldsalesform', icon: 'cilUserFollow', organisationIds: [1, 4] },
  // { slug: 'link', name: 'Import Flipkart Orders', href: '/import_flipkart', icon: 'cilCloudDownload' },
  // { slug: 'link', name: 'Calling Form', href: '/calling_form', icon: 'cilSpeech' },
  { slug: 'link', name: 'MAP Bulk', href: '/mapbulk', icon: 'cilLayers' },
  { slug: 'link', name: 'MVP Bulk', href: '/mvpbulk', icon: 'cilCopy' },
  // { slug: 'link', name: 'Patient Records', href: '/patientrecords', icon: 'cilFile' },

  { slug: 'title', name: 'Attendance' },
  {
    slug: 'dropdown',
    name: 'Attendance',
    icon: 'cilClock',
    elements: [
      { slug: 'link', name: 'Hours Report', href: '/attendance/hours', icon: 'cilCalendar' },
      { slug: 'link', name: 'Payroll Insights', href: '/attendance/monthly', icon: 'cilCash' },
      { slug: 'link', name: 'Coimbatore Branch', href: '/attendance/hours?device=a4:d5:c2:40:e8:2c', icon: 'cilBuilding' },
      { slug: 'link', name: 'Devices', href: '/attendance/devices', icon: 'cilDevices' },
      { slug: 'link', name: 'PIN → Staff Mapping', href: '/attendance/pins', icon: 'cilFingerprint' },
    ],
  },

  { slug: 'title', name: 'CRM & Calls' },
  {
    slug: 'dropdown',
    name: 'CRM',
    icon: 'cilPeople',
    elements: [
      { slug: 'link', name: 'Customers', href: '/customers', icon: 'cilUser' },
      { slug: 'link', name: 'Tickets', href: '/alltickets', icon: 'cilTicket' },
      { slug: 'link', name: 'Add Priority Number', href: '/addpriority', icon: 'cilFlag' },
    ],
  },
  { slug: 'link', name: 'Call Log', href: '/call_log', icon: 'cilCallIncoming' },
  { slug: 'link', name: 'Field Visits', href: '/fieldvisits', icon: 'cilLocationPin', organisationIds: [1, 4] },
  // { slug: 'link', name: 'Feedback Call', href: '/feedback_call', icon: 'cilCommentSquare' },
  // { slug: 'link', name: 'MDI Feedback Call', href: '/mdi_feedback_call', icon: 'cilCommentSquare' },
  // { slug: 'link', name: 'Installments', href: '/installments', icon: 'cilCalendar' },
  // {
  //   slug: 'dropdown',
  //   name: 'Follow Ups',
  //   icon: 'cilTask',
  //   elements: [
  //     { slug: 'link', name: 'New Follow Ups', href: '/followup', icon: 'cilTask' },
  //     { slug: 'link', name: 'Customer Follow Ups', href: '/customer_followups', icon: 'cilCommentSquare' },
  //     { slug: 'link', name: 'Grade Followups', href: '/grade_followups', icon: 'cilStar' },
  //   ],
  // },
  { slug: 'link', name: 'Call Queue', href: '/callqueue', icon: 'cilCallOutgoing' },
  { slug: 'link', name: 'Call Summary', href: '/callsummary', icon: 'cilChartBar' },
  { slug: 'link', name: 'Graded Follow Ups', href: '/grade_followups', icon: 'cilStar' },

  { slug: 'title', name: 'Incentives' },
  { slug: 'link', name: 'HMS Imports', href: '/hms_imports', icon: 'cilCloudUpload' },
  { slug: 'link', name: 'Incentive Preview', href: '/incentive_preview', icon: 'cilGift' },
  { slug: 'link', name: 'Amazon Care-of', href: '/amazon_care_of', icon: 'cilAmazon' },
  { slug: 'link', name: 'Flipkart Care-of', href: '/flipkart_care_of', icon: 'cilFlipkart' },
  { slug: 'link', name: 'Website Care-of', href: '/website_care_of', icon: 'cilGlobeAlt' },
  { slug: 'link', name: 'Store Sales Care-of', href: '/store_care_of', icon: 'cilBasket' },
  { slug: 'link', name: 'Tele-Sales Accounts', href: '/tele_sales_accounts', icon: 'cilWallet' },
  { slug: 'link', name: 'Telesales Leaderboard', href: '/leaderboard', icon: 'cilCup' },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Scanner', href: '/shipping/scanner', icon: 'cilScan' },
  { slug: 'link', name: 'Packing Batches', href: '/packingBatches', icon: 'cilPackage' },
  { slug: 'link', name: 'Mark Returns', href: '/shipping/returns', icon: 'cilRefund' },
  { slug: 'link', name: 'Barcodes', href: '/barcodes', icon: 'cilBarcode' },
  // { slug: 'link', name: 'Events', href: '/events', icon: 'cilCalendar' },
  // { slug: 'link', name: 'Lead Conversions', href: '/lead-conversions', icon: 'cilUserFollow' },
  // { slug: 'link', name: 'Stock Updates', href: '/stock', icon: 'cilGrid' },

  { slug: 'title', name: 'Finance & Exports' },
  {
    slug: 'dropdown',
    name: 'Payments',
    icon: 'cilDollar',
    elements: [
      { slug: 'link', name: 'COD Payments', href: '/pendingpayments', icon: 'cilHandCoin' },
      { slug: 'link', name: 'Razorpay Transactions', href: '/razorpay-transactions', icon: 'cilCreditCard' },
      // { slug: 'link', name: 'Upload VPP PDF', href: '/uploadvpp', icon: 'cilFile' },
      // { slug: 'link', name: 'Upload COD CSV', href: '/uploadcsv', icon: 'cilFile' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Exports',
    icon: 'cilShareArrow',
    elements: [
      { slug: 'link', name: 'Tally Export', href: '/tallyexport', icon: 'cilSpreadsheet' },
      { slug: 'link', name: 'Zoho Export', href: '/zohoexport', icon: 'cilFile' },
      { slug: 'link', name: 'Verify Zoho Invoices', href: '/Verifyzohoinvoices', icon: 'cilCheckCircle' },
    ],
  },
  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
  { slug: 'link', name: 'Refunds', href: '/refund', icon: 'cilMoneyBack' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },

  { slug: 'title', name: 'Settings' },
  { slug: 'link', name: 'Settings', icon: 'cilSettings', href: '/settings' },
]
